import React from 'react';
import { Box } from '../Rebass';
import styled from '@emotion/styled';
import { Meta, Heading, Text } from '../..';
import theme from '../../theme';
import { CardTextProps } from './types';

const StyledCard = styled(Box)`
  border: 1px solid ${theme.colors.baseGrayLight};
  vertical-align: top;
`;

const CardText = ({
  headline,
  subtitle,
  description,
  children,
  meta,
  ...props
}: CardTextProps) => (
  <StyledCard px={[4]} py={[5]} {...props}>
    {headline && (
      <Heading size="h4" fontWeight={'normal'} mb={[1]}>
        {headline}
      </Heading>
    )}

    {subtitle && (
      <Box mb={[3]}>
        <Text size="small">{subtitle}</Text>
      </Box>
    )}

    {description && (
      <Box mb={[8]}>
        <Text size="body" sx={{ whiteSpace: 'pre-line' }}>
          {description}
        </Text>
      </Box>
    )}

    {meta && <Meta meta={meta} />}

    {children && <Box mt={[3]}>{children}</Box>}
  </StyledCard>
);

export default CardText;
